import { Box, Divider, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { Share } from '../../../Share';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';
import { TherapySuppliersContext } from 'Context/SuppliersContext/TherapySuppliersContext';
import {
  ISupplier,
  supplierResourceFilterMapper,
} from 'Utils/suppliersResources';
import { ISuppliersResult } from 'API/Suppliers/suppliers';

interface ITitle {
  data: ISuppliersResult;
}
export const Title = ({ data }: ITitle) => {
  const { expertise, resources } = useContext(TherapySuppliersContext);
  const isDesktop = useIsDesktop();

  const supplierSpecialties = supplierResourceFilterMapper(
    resources.SPECL as ISupplier,
    data.specialties
  );

  const supplierExpertise = supplierResourceFilterMapper(
    expertise as ISupplier,
    data.expertises
  );

  const mapResourceWithCommaHandler = (resourceArr: string[]) => {
    return resourceArr.map((resource: string, index: number) => {
      return `${resource}${index < resourceArr.length - 1 ? ', ' : ''}`;
    });
  };

  return (
    <Stack gap='8px'>
      <Stack direction='row' gap={isDesktop ? '10px' : '6px'}>
        <Typography
          variant='h5'
          component='h3'
          sx={{
            cursor: 'text',
            whiteSpace: 'nowrap',
          }}
        >
          {data.name}
        </Typography>
        {supplierSpecialties.length > 0 && (
          <Divider
            orientation='vertical'
            sx={{
              height: '20px',
              borderColor: '#2E3439',
              mt: isDesktop ? '5px' : '2px',
            }}
          />
        )}
        <Typography
          variant='body2'
          sx={{
            maxWidth: '375px',
            cursor: 'text',
            mt: isDesktop ? '2px' : 0,
          }}
        >
          {supplierSpecialties.length > 0 &&
            mapResourceWithCommaHandler(supplierSpecialties)}
        </Typography>
        {!isDesktop && (
          <Box
            sx={{
              position: 'absolute',
              top: '10px',
              right: 0,
            }}
          >
            <Share data={data} />
          </Box>
        )}
      </Stack>
      <Typography
        variant='body6'
        sx={{
          width: 'fit-content',
          cursor: 'text',
        }}
      >
        {supplierExpertise.length > 0 &&
          Dictionary[DICTIONARY.Suppliers].resultPage.therapy.speciality}{' '}
        {mapResourceWithCommaHandler(supplierExpertise)}
      </Typography>
    </Stack>
  );
};
